var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "incident-report-wrapper",
      "data-test": "outside-vif"
    }
  }, [_vm.hasErrors ? [_c('div', {
    key: _vm.hasErrors,
    staticClass: "messages error messages--error"
  }, [_c('b', [_vm._v("Please correct the following error(s):")]), _vm._v(" "), _c('ul', _vm._l(_vm.getErrors, function (error, index) {
    return _c('li', {
      key: 'error-' + index
    }, [_vm._v("\n          " + _vm._s(error) + "\n        ")]);
  }), 0)])] : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.introMsg)
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Form fields that are required are marked with an asterisk (*).")]), _vm._v(" "), _c('b-form', {
    staticClass: "raft-b4"
  }, [_vm._l(_vm.shownFields, function (field) {
    return [field.field_name === 'field_in_report_building' ? _c('single-select-filter', {
      key: field.field_name,
      staticClass: "incident-report-location-field",
      attrs: {
        "get-value": _vm.filteredBuildings,
        "id": "building-fil",
        "data-test": "building-filter",
        "multiple": false,
        "label": "Building",
        "store-watch": "getSelectedBuildingsFilter",
        "display-value": "title",
        "track-by": "uuid"
      },
      on: {
        "update-filter": function (payload) {
          return _vm.updateSelectedBuildings(payload.itemsSelected);
        }
      }
    }) : field.field_name === 'field_in_report_space_room' ? _c('single-select-filter', {
      key: field.field_name,
      staticClass: "incident-report-location-field",
      attrs: {
        "get-value": _vm.buildingSpaces,
        "id": "space-fil",
        "data-test": "space-filter",
        "multiple": false,
        "label": "Space/Room",
        "display-value": "title",
        "store-watch": "getSelectedSpacesFilter",
        "update-method": _vm.updateSelectedSpace,
        "track-by": "uuid",
        "disable": _vm.spaceFilterDisabled
      }
    }) : field.field_name === 'field_in_report_upload_photos' ? _c('raft-file-upload', {
      key: field.field_name,
      attrs: {
        "field-name": field.field_name,
        "label": field.label,
        "data-test": "upload-photos",
        "description": field.description,
        "field-config": field,
        "required": field.required,
        "multiple": true,
        "disable-removals": _vm.submitDisabled,
        "suppress-replace-warning": ""
      },
      on: {
        "fileUploaded": function ($event) {
          return _vm.handleFileSelectionAction($event);
        }
      }
    }) : !_vm.skipField(field) ? _c('entity-form-field', {
      key: field.field_name,
      staticClass: "form-control form-control-warning",
      class: _vm.isInvalid(field.field_name),
      attrs: {
        "field-data": field,
        "disabled": field.disabled,
        "entity-type": "node",
        "bundle": "incident_report",
        "data-test": field.field_name,
        "placeholder": _vm.entityFormHelper.getPlaceholder(field),
        "add-class": _vm.addClass(field.field_name),
        "styled": _vm.isStyled[field.field_name]
      },
      on: {
        "change": _vm.updateFormData,
        "update-form-data": _vm.updateFormData,
        "date-error-message": _vm.catchDateError
      }
    }) : _vm._e()];
  }), _vm._v(" "), _c('b-form-row', [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmitAction();
      }
    }
  }, [_vm._v("\n        Submit\n      ")]), _vm._v(" "), _c('b-link', {
    attrs: {
      "href": "#",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.handleCancelAction();
      }
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "busy-wrapper"
  }, [_vm.isBusy ? _c('raft-busy', {
    attrs: {
      "busy-text": _vm.busyText
    }
  }) : _vm._e()], 1)], 1)], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }